<template>
    <div class="flex items-center flex-1 rounded w-full h-full" :class="mainClasses">
        <div class="relative">
            <div
                data-test="error-message"
                class="text-red-600 italic absolute inset-0 -mt-6"
                v-text="$t('composer.validUrl')"
                v-if="hasError"
            />
            <div class="flex items-center justify-center mx-2">
                <activix-input
                    data-test="image-url-input"
                    :class="small ? 'w-64' : 'w-96'"
                    :placeholder="$t('composer.imageUrl')"
                    @keydown.enter="setImage(linkUrl)"
                    v-model="linkUrl"
                />
                <activix-button
                    data-test="insert-button"
                    type="primary"
                    class-names="h-20 m-0 p-0"
                    @click="setImage(linkUrl)"
                >
                    {{ $t('composer.insert') }}
                </activix-button>
            </div>
        </div>
        <div class="w-full flex items-center justify-center">
            <activix-drag-upload
                data-test="drag-upload"
                :class="small ? 'w-96 mt-2' : 'mt-12 w-1/3'"
                :description="$t('composer.dropImage')"
                :accepts="['image/*', '.png']"
                :display-item-card="false"
                @update:model-value="dropImage"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import ActivixDragUpload from '@/components/elements/ActivixDragUpload.vue';

    interface State {
        hasError: boolean;
        linkUrl: string;
    }

    export default defineComponent({
        name: 'ComposerImage',

        components: {
            ActivixDragUpload,
        },

        emits: ['set-files', 'set-image'],

        props: {
            small: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                hasError: false,
                linkUrl: '',
            } as State;
        },

        computed: {
            mainClasses(): string {
                return this.small ? 'justify-between w-full px-8' : 'flex-col justify-center';
            },
        },

        methods: {
            dropImage(event: any): void {
                this.$emit('set-files', event);
            },

            setImage(link: string): void {
                if (link && !this.urlIsValid(link)) {
                    this.hasError = true;
                    return;
                }

                this.hasError = false;
                this.$emit('set-image', link);
            },
        },
    });
</script>
